'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

RouteMapDirective=class RouteMapDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/directives/routeMapDirective/routeMapTemplate';
}
get objectBindings(){
return[
'routePath',
'stops'];

}
get controller(){
return Controller;
}};let


Controller=class Controller{
static get $inject(){return['$scope','leafletBoundsHelpers']}

constructor($scope,leafletBoundsHelpers){
this._leafletBoundsHelpers=leafletBoundsHelpers;

this.leafletPaths=this._createLeafletPathFromRoutePath();
this.leafletMarkers=this._createLeafletMarkersFromRouteStops();

this.routeBounds=this._getRouteBounds();
}

_createLeafletMarkersFromRouteStops(){
if(!_.exists(this.stops)){
return[];
}

return this.stops.map(s=>{

let{street,city,state,zip}=s.location;
let addressString=_.compact([street,city,state,zip]).join(', ');

let stopType=s.stopType==='drophook'?'Drop and Hook':s.stopType;

let message=stopType==='none'?addressString:`${_.upperFirst(s.stopType)}: ${addressString}`;

return{
lat:s.location.latlng.lat,
lng:s.location.latlng.lng,
message:message,
focus:!1,
draggable:!1};

});
}

_createLeafletPathFromRoutePath(){
if(!_.exists(this.routePath)){
return[];
}

let routePathColor='#758FF2';
let routePathWeight=8;
let leafletPathObject={
color:routePathColor,
weight:routePathWeight,
latlngs:this.routePath};


return[leafletPathObject];
}

_getRouteBounds(){
let latitudes=_.map(this.routePath,'lat');
let longitudes=_.map(this.routePath,'lng');

let northernLatitude=_.max(latitudes);
let southernLatitude=_.min(latitudes);
let westernLongitude=_.max(longitudes);
let easternLongitude=_.min(longitudes);

let pathLocationsArray=[
[northernLatitude,easternLongitude],
[southernLatitude,westernLongitude]];


return this._leafletBoundsHelpers.createBoundsFromArray(pathLocationsArray);
}};


module.exports=RouteMapDirective;
//# sourceMappingURL=routeMapDirective.js.map
